import * as _ from 'lodash';

const PAYPAL_CLIENT_ID = process.env.PAYPAL_CLIENT_ID;
const STRIPE_CLIENT_ID = process.env.STRIPE_CLIENT_ID;

export function getStripeScriptLocation() {
    return `https://js.stripe.com/v3/`;
}
export function getPaypalScriptLocation() {
    return `https://www.paypal.com/sdk/js?client-id=${PAYPAL_CLIENT_ID}&currency=USD`;
}

export function getStripeKey() {
    return STRIPE_CLIENT_ID;
}

export function isAnyPaymentAvailable(features) {
    return isStripePaymentAvailable(features) || isPaypalPaymentAvailable(features);
}

export function isStripePaymentAvailable(features) {
    if (features?.billing?.enabled === true && features?.billing?.payment?.stripe?.enabled === true) {
        if (STRIPE_CLIENT_ID && _.isString(STRIPE_CLIENT_ID) &&
            STRIPE_CLIENT_ID.indexOf('$STRIPE') === -1) {
            return true;
        } else {
            console.warn('Specify env variables for payments with Stripe');
        }
    }

    return false;
}

export function isPaypalPaymentAvailable(features) {
    if (features?.billing?.enabled === true && features?.billing?.payment?.paypal?.enabled === true) {
        if (PAYPAL_CLIENT_ID && _.isString(PAYPAL_CLIENT_ID)
        ) {
            return true;
        } else {
            console.warn('Specify env variables for payments with PayPal');
        }
    }

    return false;
}